import { createFileRoute, Navigate } from '@tanstack/react-router';
import { accountCan, roleKnown } from '../../features/teams/access';
import { TEAMS_ENABLED } from '../../features/teams/teamsEnabled';
import { useCurrentAccount } from '../../features/teams/useCurrentAccount';
import { AuditLogPage } from '../../pages/dashboard/audit-log/AuditLogPage';

export const Route = createFileRoute('/dashboard/audit-log')({ component: AuditLogRoute });

/** The audit log is a Team Admin's only: with Teams off, on a personal
 *  account, or for any other role, the address is the dashboard. It waits
 *  while a Team member's role is still being read. */
function AuditLogRoute() {
  const { access } = useCurrentAccount();
  if (!TEAMS_ENABLED) return <Navigate to="/dashboard" replace />;
  if (!roleKnown(access)) return null;
  return accountCan(access, 'viewAuditLog') ? <AuditLogPage /> : <Navigate to="/dashboard" replace />;
}
